import { render, staticRenderFns } from "./PublicationTrack.vue?vue&type=template&id=696d1aae&scoped=true"
import script from "./PublicationTrack.vue?vue&type=script&lang=js"
export * from "./PublicationTrack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696d1aae",
  null
  
)

export default component.exports